"use strict";

import angular from "angular";
/**
 * @component NuMessageData
 * O <nu-header-data> - is a component used for show message and icon
 */

import template from "./message-data.component.html";
import "./message-data.component.scss";

const name = "nuMessageData";
const def = {
    bindings: {
        icon: "=",
        msg: "="
    },
    controllerAs: "messageDataCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
